/* Ficha del morral: reordena el bloque de compra del tema en dos columnas.
   El tema deja todos sus bloques en una sola pila pensada para ir al lado de la
   galería; acá la galería no está, así que se agrupan en dos contenedores:
     · izquierda  → encabezado (edición limitada + precio) y la compra
     · derecha    → upsell, íconos de envío y acordeones
   El encabezado vive en otra sección (SOFS Morral · Compra): se trae acá para
   que no quede como una franja suelta arriba. */
(function () {
  'use strict';

  function armar() {
    var form = document.querySelector('.form__wrapper');
    if (!form || form.dataset.sofsCols === '1') return;
    if (!document.querySelector('.bpv--pdp')) return;   // solo en la ficha del morral

    var izq = document.createElement('div');
    var der = document.createElement('div');
    izq.className = 'sofs-pdp-col sofs-pdp-col--compra';
    der.className = 'sofs-pdp-col sofs-pdp-col--extra';

    Array.prototype.slice.call(form.children).forEach(function (el) {
      if (el.tagName === 'SCRIPT' || el.tagName === 'LINK') return;
      /* El tema deja bloques sin contenido que igual ocupan margen y desnivelan
         las columnas: se apagan. */
      var vacio = !el.textContent.trim() && !el.querySelector('img, svg, button, input, select');
      if (vacio) { el.style.display = 'none'; }
      /* «Arma tu outfit» también va en la columna de compra: en el DOM del tema
         viene después del formulario, así que cae justo debajo de los botones. */
      var esCompra = el.matches('product-form, .product__form__wrapper, .product__title-and-price, .product__price-and-badge, .upsell__products');
      (esCompra ? izq : der).appendChild(el);
    });

    /* Título y precio entran DENTRO del formulario, como un par pegado: así
       todos los huecos de la columna (título · talla · stock · cantidad ·
       botones) los reparte un solo contenedor y quedan iguales. */
    var pf = izq.querySelector('.product__form');
    var titulo = izq.querySelector('.product__title-and-price');
    var precio = izq.querySelector('.product__price-and-badge');
    if (pf && titulo) {
      var cabecera = document.createElement('div');
      cabecera.className = 'sofs-pdp-cabecera';
      cabecera.appendChild(titulo);
      if (precio) cabecera.appendChild(precio);
      pf.insertBefore(cabecera, pf.firstChild);
      /* El bloque de la talla arrastra ~38px de aire propio y su hermano
         inmediato es un nodo invisible, así que el ajuste no se puede hacer con
         CSS: se busca el primer bloque con altura y se le resta ese aire. */
      /* Los nodos de altura 0 dentro del formulario cuentan como ítem al repartir
         y se llevan un hueco entero: por eso el primer espacio salía doble. */
      Array.prototype.slice.call(pf.children).forEach(function (el) {
        if (el === cabecera) return;
        /* Ojo: solo se apagan los que NO tienen contenido. Si se mide por alto
           nada más, se apaga la barra de disponibilidad antes de que se pinte. */
        if (!el.textContent.trim() && el.getBoundingClientRect().height === 0 && !el.querySelector('img, svg, button, input, select')) el.style.display = 'none';
      });
      var siguiente = null;
      for (var n = cabecera.nextElementSibling; n; n = n.nextElementSibling) {
        if (n.getBoundingClientRect().height > 0) { siguiente = n; break; }
      }
      if (siguiente) siguiente.style.marginTop = '-38px';
    }

    form.appendChild(izq);
    form.appendChild(der);
    form.dataset.sofsCols = '1';

    /* El carrusel del upsell mide su ancho al iniciarse: tras moverlo de columna
       hay que pedirle que vuelva a medir, si no queda con el ancho viejo. */
    var remedir = function () { window.dispatchEvent(new Event('resize')); };
    window.addEventListener('load', remedir);
    setTimeout(remedir, 700);

    /* Nivelar el cierre de las dos columnas: la de compra copia el alto de la
       otra UNA vez, al cargar. Si después se abre un acordeón, la izquierda
       crece y la de compra se queda quieta (con stretch se le corría todo). */
    function nivelar() {
      if (!window.matchMedia('(min-width: 990px)').matches) { izq.style.minHeight = ''; return; }
      izq.style.minHeight = '';
      var alto = der.getBoundingClientRect().height;
      if (alto > izq.getBoundingClientRect().height) izq.style.minHeight = Math.round(alto) + 'px';
    }
    nivelar();
    window.addEventListener('load', nivelar);
    setTimeout(nivelar, 600);
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(nivelar, 150); }, { passive: true });
  }

  if (document.readyState !== 'loading') armar();
  else document.addEventListener('DOMContentLoaded', armar);
})();
